import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { App, Button } from 'antd';
import { txt } from 'libs/i18n';
const NewVersionNotice = ({ newVersionAvailable }) => {
    const { notification } = App.useApp();
    useEffect(() => {
        if (!newVersionAvailable) {
            return;
        }
        notification.info({
            message: txt('newVersionAvailable'),
            description: (_jsx(Button, { onClick: () => { window.location.reload(); }, children: txt('reload') })),
            placement: 'topRight',
            duration: 0,
        });
    }, [newVersionAvailable]);
    return null;
};
export default NewVersionNotice;
